import {onFind} from "@elements/init-modules-in-scope";
import {on, addClass, removeClass, hasClass} from '@elements/dom-utils';

const selectors = {
    base: '.js-disable-submit-btn'
};

const disabledClass = 'cart-btn__submit--disabled';

// safety net: if navigation never happens (offline, blocked, …) re-enable the button so the user can retry
const reEnableTimeout = 8000;

function disable(button) {
    addClass(disabledClass, button);
    button.setAttribute('aria-disabled', 'true');
}

function enable(button) {
    removeClass(disabledClass, button);
    button.removeAttribute('aria-disabled');
}

export function init () {
    onFind(selectors.base, function (button) {
        on('click', function (evt) {
            // block every click after the first one (the first click's navigation is left untouched)
            if (hasClass(disabledClass, button)) {
                evt.preventDefault();
                return;
            }

            disable(button);

            // if we're still on this page after the timeout, the navigation didn't take – allow a retry
            setTimeout(function () {
                enable(button);
            }, reEnableTimeout);
        }, button);

        // back-button / bfcache restores the page with the old (disabled) DOM – reset it so it's clickable again
        on('pageshow', function (evt) {
            if (evt.persisted) {
                enable(button);
            }
        }, window);
    });
}
